import Vue from 'vue';
import VueI18n from 'vue-i18n';
import index from './sfc/index.vue';
import router from './router';
import store from './store';
import iView from 'iview';
import '@/locale';
// import security from "./security";
import 'iview/dist/styles/iview.css';
// import enLang from './locale/en-US/index';
// import zhLang from './locale/zh-CN/index';
import * as zhLang from '../static/json/zh.json';
import * as enLang from '../static/json/en.json';
import zh from 'iview/src/locale/lang/zh-CN';
import en from 'iview/src/locale/lang/en-US';
import locale from "./locale/index";
import axios from "axios";
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
//使用安全控制
// Vue.use(security);
Vue.use(iView);
Vue.use(VueI18n);
var lang = locale.getLang();
var i18n = new VueI18n({
    locale: lang,
    messages: {
        'zh-CN': Object.assign(zh, zhLang['zh-CN']),
        'en-US': Object.assign(en, enLang['en-US'])
    }
});
new Vue({
    i18n: i18n,
    el: '#index',
    router: router,
    store: store,
    render: function (h) { return h(index); }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = null
// module chunks = 